import {RemoteDeclineWellBornProgram} from 'data/usecases/private/well-born/remote-decline-program';
import {PostDeclineWellBornProgram} from 'domain/usecases/private/well-born/post-decline-well-born-program';
import {makeAxiosHttpClient} from 'main/factories/http/axios-http-client-factory';
import {WellBornEndpoints} from 'main/factories/usecases/endpoints';

export const makePostDeclineWellBornProgram = (): PostDeclineWellBornProgram =>
	new RemoteDeclineWellBornProgram(WellBornEndpoints.declineProgram, makeAxiosHttpClient());
